import * as t from 'io-ts';
import type { TypeOf } from 'io-ts';
import OneOf from '@/scripts/io-ts/OneOf';
import FIELD_RENDER_TYPES from '@/scripts/helpers/fieldRenderTypes';
import fromEnum from '@/scripts/io-ts/fromEnum';
import { HintC } from '@/scripts/helpers/schemaConverter/converters/types/Hint';

export const ALLOWED_TYPES = [
    'file',
    'multi_files',
    'boolean',
    'array',
    'object',
    'radio_checkbox_tree',
    'string',
    'integer',
    'hidden',
] as const;

const FieldNonRecursiveCommonPropsC = t.intersection([
    t.type({
        title: t.union([t.string, t.null]),
        name: t.string,
        type: OneOf(ALLOWED_TYPES),
        errors: t.array(t.string),
        tooltip: t.union([t.string, t.null]),
        hint: t.union([HintC, t.null]),
        disabled: t.boolean,
        updateOnChange: t.boolean,
        updateDebounce: t.boolean,
        renderAs: fromEnum('FIELD_RENDER_TYPES', FIELD_RENDER_TYPES),
    }),
    t.partial({
        labelCaption: t.string,
        propertyOrder: t.number,
        isRequired: t.boolean,
        value: t.unknown,
        initialValue: t.unknown,
        show: t.boolean,
        maxLength: t.union([t.number, t.null, t.undefined]),
        labelAttr: t.union([t.record(t.string, t.unknown), t.null]),
        metadata: t.record(t.string, t.unknown),
        errorPaths: t.array(t.string),
    }),
],
'FieldNonRecursiveCommonProps');

const FieldRecursiveCommonPropsC = t.partial({
    fields: t.record(t.string, FieldNonRecursiveCommonPropsC),
},
'FieldRecursiveCommonProps');

export const FieldCommonPropsC = t.intersection([
    FieldNonRecursiveCommonPropsC,
    FieldRecursiveCommonPropsC,
],
'FieldCommonProps');

export type FieldCommonProps = TypeOf<typeof FieldCommonPropsC>;
